<template>
  <section class="section">
    <nav class="level">
      <div class="level-item has-text-centered">
        <div>
          <p class="heading">Total applications</p>
          <p class="subtitle is-3">{{ this.$store.state.clientsTotal | numberDisplay }}</p>
        </div>
      </div>
      <div class="level-item has-text-centered">
        <div>
          <p class="heading">Total devices</p>
          <p class="subtitle is-3">{{ this.$store.state.devicesTotal | numberDisplay }}</p>
        </div>
      </div>
      <div class="level-item has-text-centered">
        <div>
          <p class="heading">Total cameras</p>
          <p class="subtitle is-3">{{ this.$store.state.camerasTotal | numberDisplay }}</p>
        </div>
      </div>
    </nav>
    <div class="columns">
      <div class="column is-5 is-offset-1">
        <article class="box">
          <h5 class="subtitle is-5">Devices by platforms</h5>
          <chartjs-pie
            v-bind:labels="deviceLabels"
            v-bind:data="deviceData"
            v-bind:backgroundcolor="deviceBackgroundColor"
            v-bind:hoverbackgroundcolor="deviceHoverBackgroundColor"
            v-bind:bind="true"
            v-bind:scalesdisplay="false"
            v-bind:option="myoption">
          </chartjs-pie>
        </article>
      </div>
      <div class="column is-5">
        <article class="box">
          <h5 class="subtitle is-5">Cameras by platforms</h5>
          <chartjs-pie
            v-bind:labels="cameraLabels"
            v-bind:data="cameraData"
            v-bind:backgroundcolor="cameraBackgroundColor"
            v-bind:hoverbackgroundcolor="cameraHoverBackgroundColor"
            v-bind:bind="true"
            v-bind:scalesdisplay="false"
            v-bind:option="myoption">
        </chartjs-pie>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    data () {
      return {
        myoption: {},
        // Devices by platforms pie chart
        deviceLabels: ['Android', 'iOS'],
        deviceBackgroundColor: [
          'rgba(164, 198, 57, 0.7)',
          'rgba(95, 201, 248, 0.7)'
        ],
        deviceHoverBackgroundColor: [
          'rgba(164, 198, 57, 1)',
          'rgba(95, 201, 248, 1)'
        ],

        // Cameras by platforms pie chart
        cameraLabels: ['Novatek', 'Ambarella', 'AIT', 'Otus', 'iCatch', 'Etron'],
        cameraBackgroundColor: [
          'rgba(255, 99, 132, 0.7)',
          'rgba(54, 162, 235, 0.7)',
          'rgba(255, 206, 86, 0.7)',
          'rgba(75, 192, 192, 0.7)',
          'rgba(153, 102, 255, 0.7)',
          'rgba(255, 115, 04, 0.7)'
        ],
        cameraHoverBackgroundColor: [
          'rgba(255,99,132,1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(75, 192, 192, 1)',
          'rgba(153, 102, 255, 1)',
          'rgba(255, 115, 04, 1)'
        ]
      }
    },

    computed: {
      deviceData () {
        return [
          this.$store.state.androidDevicesTotal,
          this.$store.state.iosDevicesTotal
        ]
      },

      cameraData () {
        return [
          this.$store.state.novatekCamerasTotal,
          this.$store.state.ambarellaCamerasTotal,
          this.$store.state.aitCamerasTotal,
          this.$store.state.otusCamerasTotal,
          this.$store.state.icatchCamerasTotal,
          this.$store.state.etronCamerasTotal
        ]
      }
    },

    created () {
      this.$store.dispatch('getClients', { limit: 1 })
      this.$store.dispatch('getDevices', { limit: 1 })
      this.$store.dispatch('getCameras', { limit: 1 })
      this.$store.dispatch('getAndroidDevicesTotal')
      this.$store.dispatch('getIosDevicesTotal')
      this.$store.dispatch('getNovatekCamerasTotal')
      this.$store.dispatch('getAmbarellaCamerasTotal')
      this.$store.dispatch('getAitCamerasTotal')
      this.$store.dispatch('getOtusCamerasTotal')
      this.$store.dispatch('getIcatchCamerasTotal')
      this.$store.dispatch('getEtronCamerasTotal')
    }
  }
</script>



// WEBPACK FOOTER //
// Home.vue?46d39201